"use client";

import React from "react";
import { Megaphone, MessageCircle, CalendarCheck, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const steps = [{
  id: 1,
  title: "Inspection",
  description: "Our experts conduct a rigorous structural assessment of your roof to identify vulnerabilities and hidden moisture ingress points.",
  icon: Megaphone
}, {
  id: 2,
  title: "Strategy",
  description: "We engineer a bespoke protection plan, selecting industrial-grade materials tailored to your building's specific architectural needs.",
  icon: MessageCircle
}, {
  id: 3,
  title: "Execution",
  description: "Our skilled team implements the solution with surgical precision, ensuring every seal and shingle meets our elite quality standards.",
  icon: CalendarCheck
}];
export default function The3StepPatientJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223380" id="the-rm-shield-process" className="dark bg-background py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(hsl(var(--primary)/0.1)_1px,transparent_1px)] [background-size:32px_32px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-extrabold font-default text-foreground mb-4 tracking-tighter">
            The RM Shield Process
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Our systematic approach to structural integrity ensures your property remains impenetrable against the elements.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="hidden md:block absolute top-[3.5rem] left-[16%] right-[16%] h-0.5 border-t-2 border-dashed border-primary/30 z-0" />

          {}
          <div className="md:hidden absolute top-[10%] bottom-[10%] left-[3.25rem] w-0.5 border-l-2 border-dashed border-primary/30 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
            {steps.map((step, i) => {
            const Icon = step.icon;
            return <div key={step.id} data-index={i} className="relative z-10 flex flex-col items-start md:items-center text-left md:text-center group">
                  <div className="flex flex-row md:flex-col items-center md:items-center gap-6 md:gap-6 w-full">
                    {}
                    <div className="relative shrink-0">
                      <div className="absolute inset-0 bg-primary/10 rounded-full blur-2xl group-hover:bg-primary/20 transition-colors duration-500" />
                      <div className="relative w-20 h-20 md:w-28 md:h-28 rounded-full bg-card border border-border flex items-center justify-center shadow-lg group-hover:shadow-primary/20 transition-shadow duration-500">
                        <Icon className="w-8 h-8 md:w-12 md:h-12 text-primary" strokeWidth={1.5} />
                        
                        {}
                        <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-sm shadow-md border-2 border-background font-mono">
                          0{step.id}
                        </div>
                      </div>
                    </div>

                    {}
                    <div className="flex-1 md:w-full">
                      <h3 className="text-xl md:text-2xl font-bold font-default text-foreground mb-3 tracking-tight">
                        {step.title}
                      </h3>
                      <p className="text-muted-foreground font-sans leading-relaxed text-sm md:text-base">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>

        <div className="mt-20 text-center">
          <Button asChild size="lg" className="rounded-full px-10 font-default font-bold bg-primary text-primary-foreground hover:opacity-90 transition-opacity">
            <Link to="#">
              Secure Your Property <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}